// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"136f8a05","453":"c9db9971","455":"4b3d10d3","977":"9d17aaed"}[chunkId] + ".chunk.js";
};